import React from 'react';
import IntlMessages from '../../../util/IntlMessages';

interface ICatalogueControlsProps {
  gymName: string;
  startDate: string;
  isSaving: boolean;
  onStartDateChange: (startDate: string) => void;
}

const CatalogueControls: React.FC<ICatalogueControlsProps> = ({
  gymName,
  startDate,
  isSaving,
  onStartDateChange,
}) => (
  <div className='group-catalogue__controls'>
    <div className='group-catalogue__input-label'>
      <IntlMessages id='groups.catalogue.gym' />
      <div className='group-catalogue__static-value'>{gymName}</div>
    </div>
    <label className='group-catalogue__input-label'>
      <IntlMessages id='groups.catalogue.startDate' />
      <input
        type='date'
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        required
        className='group-catalogue__input-field'
        disabled={isSaving}
      />
    </label>
  </div>
);

export default CatalogueControls;
